module.exports = __webpack_public_path__ + "static/img/album01_0.7ab3d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album01/album01_0.png
// module id = Kjsv
// module chunks = 1